
<template>
  <div
    @dragenter.prevent="toggleActive"
    @dragleave.prevent="toggleActive"
    @dragover.prevent
    @drop.prevent="toggleActive"
    :class="{ 'active-dropzone': active }"
    class="dropzone position-relative"
  >
    <div class="mb-1">
        <i class="display-4 text-muted ri-upload-cloud-2-fill"></i>
    </div>

    <h5>{{ $t('page.drag-drop-or-click-to-upload') }}</h5>
    <label :for="inputFileId" class="bg-light text-dark stretched-link">{{ $t('base.upload') }}</label>
   <input type="file" :id="inputFileId" class="dropzoneFile btn btn-primary" :multiple="multiple" />
  </div>
</template>


<script>
import { ref } from "vue";
export default {
  name: "dropzone",
  setup() {
    const active = ref(false);
    const toggleActive = () => {
      active.value = !active.value;
    };
    return { active, toggleActive };
  },
  props: {
    inputFileId: {
      type: String,
      default: 'dropzoneFile'
    },
    multiple: {
      type: Boolean,
      default: false
    }
  }
};
</script>
